const savedRugFieldsEl = document.querySelector('.customer__saved-rug-fields');
const savedBordersEl = document.querySelector('.customer__saved-borders');
const savedWallcoveringsEl = document.querySelector('.customer__saved-wallcoverings');
const overlayEl = document.querySelector('.overlay');
const overlaySuccessEl = document.querySelector('.overlay__success');
const overlayFailEl = document.querySelector('.overlay__fail');

const createAccessToken = async function(user, pass) {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type':'application/json',
      'X-Shopify-Storefront-Access-Token':'069aee46a2e0fc4d87a8c443c62a69ca'
    },
    body: JSON.stringify({
      query: `mutation customerAccessTokenCreate {
  customerAccessTokenCreate(input: {email: "${user}", password: "${pass}"}) {
    customerAccessToken {
      accessToken
    }
    customerUserErrors {
      message
    }
  }
}
`
    })
  }
  const accessToken = await fetch('/api/2023-07/graphql.json', options).then(res => res.json())
  console.log(accessToken);
}

const getJSON = function ([product, variant], errMsg = 'Something went wrong') {
  return fetch('/api/2024-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type':'application/json',
      'X-Shopify-Storefront-Access-Token':'f9f28e22142146072bb46fa427213264'
    },
    body: JSON.stringify({
      query: `{
      product(id: "gid:\/\/shopify\/Product\/${product}") {
      title
      handle
      variants(first: 50) {
      nodes {
      id
      image {
      url
      }
      title
      sku
      }
      }
      }
      }
      `
    })
  }).then(res => {
   if (!res.ok) console.log(res);
    return res.json()
  })
};

const deleteProduct = function(str, i) {
  if (!confirm('Are you sure you want to delete?')) return;
  if (str === 'rug-fields') {
    customer.savedRugFields.splice(i, 1);
    const el = document.getElementById(`saved-info-${str}-${i}`)
    ravenSubmitSavedRugFields(JSON.stringify(customer.savedRugFields), el);
  }
  if (str === 'borders') {
    customer.savedBorders.splice(i, 1);
    const el = document.getElementById(`saved-info-${str}-${i}`)
    ravenSubmitSavedBorders(JSON.stringify(customer.savedBorders), el);
  }
  if (str === 'wallcoverings') {
    customer.savedWallcoverings.splice(i, 1);
    const el = document.getElementById(`saved-info-${str}-${i}`)
    ravenSubmitSavedWallcoverings(JSON.stringify(customer.savedWallcoverings), el);
  }
}

const displayProducts = function(arr, el, str) {
  if (arr.length > 0) {
  arr.forEach((obj, i) => {
  const html = `
  <div class="single-saved-rug" id="saved-info-${str}-${i}">
  <div class="rug-saved-image">
    <div class="green-overlay">
      <div class="green-overal__wrapper">
        <a href="/products/${obj.productHandle}?variant=${obj.variantID}">View Product
          <figure class="saved-item__icon"><svg id="Capa_1" viewBox="0 0 189.524 189.524" xmlns="http://www.w3.org/2000/svg" style="--viewbox-width: 189.524; --viewbox-height: 189.524;"><path d="M127.929 142.143c29.513 0 52.119-21.913 52.119-47.381s-22.606-47.381-52.119-47.381c-27.669 0-49.267 19.26-51.858 42.651-.288 2.601-2.382 4.73-4.999 4.73s-4.76-2.129-4.527-4.735c2.607-29.186 29.095-52.122 61.385-52.122 34.018 0 61.595 25.456 61.595 56.857s-27.578 56.857-61.595 56.857a4.739 4.739 0 01-.001-9.476z"></path><path d="M61.595 47.381c-29.513 0-52.119 21.913-52.119 47.381s22.606 47.381 52.119 47.381c27.669 0 49.267-19.259 51.858-42.651.289-2.601 2.383-4.73 5-4.73 2.616 0 4.76 2.129 4.528 4.735-2.607 29.186-29.095 52.122-61.385 52.122C27.577 151.619 0 126.163 0 94.762s27.577-56.857 61.595-56.857a4.738 4.738 0 110 9.476z"></path></svg></figure>
        </a>
        <a href="#" onclick="event.preventDefault(); deleteProduct('${str}', ${i})">Delete Product
          <figure class="saved-item__icon"><svg id="Capa_1" viewBox="0 0 180.048 180.048" xmlns="http://www.w3.org/2000/svg" style="--viewbox-width: 180.048; --viewbox-height: 180.048;"><path clip-rule="evenodd" d="M61.595 9.476h56.857a9.476 9.476 0 019.476 9.476v9.476h-75.81v-9.476c.001-5.233 4.244-9.476 9.477-9.476zM42.643 28.429v-9.476C42.643 8.485 51.128 0 61.595 0h56.857c10.467 0 18.952 8.485 18.952 18.952v9.476h28.429a4.738 4.738 0 010 9.476H14.214a4.738 4.738 0 110-9.476h28.429zm18.952 127.928a4.738 4.738 0 01-4.738-4.738V80.548a4.738 4.738 0 019.476 0v71.071a4.738 4.738 0 01-4.738 4.738zm28.429 0a4.739 4.739 0 01-4.738-4.738V80.548a4.739 4.739 0 019.476 0v71.071a4.739 4.739 0 01-4.738 4.738zm28.428 0a4.739 4.739 0 01-4.738-4.738V80.548a4.739 4.739 0 019.476 0v71.071a4.738 4.738 0 01-4.738 4.738z" fill-rule="evenodd"></path><path clip-rule="evenodd" d="M28.429 170.571V56.857a4.738 4.738 0 119.476 0v104.238a9.476 9.476 0 009.476 9.476h85.286a9.475 9.475 0 009.476-9.476V56.857a4.738 4.738 0 019.476 0v113.714a9.475 9.475 0 01-9.476 9.476H37.905c-5.234.001-9.476-4.242-9.476-9.476z" fill-rule="evenodd"></path></svg></figure>
        </a>
      </div>
    </div>
    <img src="${obj.img}" width="200px" height="200px">
  </div>
    <div class="dyr-line-item">
        <h4 class="dyr-label-choice">${obj.productTitle} ${obj.variantSku} ${obj.variantTitle}</h4>
    </div>
    </div>
  `
  el.insertAdjacentHTML('beforeend', html);
  })
} else {
    const html = `<p>Your saved ${str.replace('-', ' ')} will appear here.</p>`;
    el.insertAdjacentHTML('beforeend', html);
}
}
const getFavorites = async function(arr, str, el) {
  const promises = [];
  arr.forEach(obj => promises.push(getJSON([obj.product, obj.variant])));
  try {
    const saves = await Promise.all(promises);
    const rugFieldImgURLs = saves.map((obj, i) => obj.data.product.variants.nodes.find(obj => obj.id === `gid://shopify/ProductVariant/${arr[i].variant}`).image.url);
    const variantSKUs = saves.map((obj, i) => obj.data.product.variants.nodes.find(obj => obj.id === `gid://shopify/ProductVariant/${arr[i].variant}`).sku);
    const variantTitles = saves.map((obj, i) => obj.data.product.variants.nodes.find(obj => obj.id === `gid://shopify/ProductVariant/${arr[i].variant}`).title);
    const productTitles = saves.map(obj => obj.data.product.title);
    const productHandles = saves.map(obj => obj.data.product.handle);
    const saveInfo = [];
    for (let i = 0; i < arr.length; i++) {
      saveInfo.push({productTitle: productTitles[i], productHandle: productHandles[i], variantID: arr[i].variant, variantSku: variantSKUs[i], variantTitle: variantTitles[i], img: rugFieldImgURLs[i] + '&width=200'})
    }
    displayProducts(saveInfo, el, str);
  } catch (error) {
    console.log(error)
  }
}

const init = function() {
getFavorites(customer.savedRugFields, 'rug-fields', savedRugFieldsEl);
getFavorites(customer.savedBorders, 'borders', savedBordersEl);
getFavorites(customer.savedWallcoverings, 'wallcoverings', savedWallcoveringsEl);
}
init();

overlayEl.addEventListener('click', function(e) {
  overlayEl.classList.add('invisible');
  overlaySuccessEl.classList.add('invisible');
  overlayFailEl.classList.add('invisible');
})




